import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import InfoDistribution from "../../../containers/modules/master/info-distribution";

export default function InfoDistributorRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="info-distribution"
      index
      element={
        <AccessControl
          name={"Info Distribution List"}
          auth={authUser}
          component={() => <InfoDistribution authUser={authUser} />}
        />
      }
      key={"Unit List"}
    />
  );
}
